<template>
	<v-text-field :label="`Introduzca su código promocional`" autocomplete="null">
		<template v-slot:append-outer>
			<v-btn outlined color="#868c8d" @click="handlePromotionalCode"><span class="font-weight-medium fcolor-extra-dark">Validar</span></v-btn>
		</template>
	</v-text-field>
</template>

<script>
import { mapActions } from 'vuex';

export default {
	data() {
        return {
            promocode: ''
        };
    },
	methods: {
		...mapActions(['CALCULATE_TICKETS_PRICE']),
		handlePromotionalCode() {
			console.log('to implement method calculateTicketsPrice ');
			this.$emit('validatePromocode', this.promocode);
		},
		calculateTicketsPrice() {
			const ticketTypeId = this.configuration.ticketType.id;
			const ticketId = this.configuration.id;
			const action = "normal";
			this.isSelectorDisabled = true;
			const params = {
				numTickets: this.numberOfTickets,
				ticketbatchid: ticketTypeId
			};
			return this.CALCULATE_TICKETS_PRICE({ params, ticketTypeId, ticketId, action }).finally(() => {
				this.isSelectorDisabled = false;
			});
		}
	}
};
</script>

<style></style>
